import React from "react";
import { History, Link } from "react-router";
import { ZOOM_ICON } from "js/config.jsx";
import { Nav, Navbar, NavbarBrand, NavbarHeader,  NavItem , Glyphicon} from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import UserHandler from "js/utilities/user-handler";
import config from "js/config";
export default React.createClass({

  myLink: function(to, className, label) {
    function handleClick(e) {
      document.getElementsByClassName("menu")[0].click();
    };
    return (<li><Link to={to} onClick={handleClick} className={className}>{label}</Link></li>);
  },

  getInitialState () {
    let userEmail = UserHandler.getUser().email;
    return {
      userEmail: userEmail
    };
  },
  contextTypes: {
    router: React.PropTypes.object.isRequired
  },

  componentDidMount () {

    window.addEventListener('scroll', function (e) {
      if (document.getElementsByClassName("menu").length > 0) {
        if (window.pageYOffset > 40) {
          document.getElementsByClassName("menu")[0].style.top = "-56"
        }
        else {
          document.getElementsByClassName("menu")[0].style.top = "0"
        }
      }
    });
  },

  render: function() {

    var url = window.location.origin;
    if (FN_MODE !== "qa") {
      url += "/zoomsdk";
    }

    if(UserHandler.loggedIn()) {
      if(window.location.hash.indexOf("account") > -1) {
        return (
          <header className="menu">
            <div className="header_container">
              <a className="logout" onClick={this.logout}>Logout</a>
            </div>
            <button className="open-menu btn-new"><Glyphicon glyph="menu-hamburger"/></button>
          </header>
        );
      }
      else {
        return (
          <header className="menu">
            <div className="header_container">
              <Link className="logout" to="/account">My Account</Link><br/>
              <Link className="header_container_email" to="/account"><span>{this.state.userEmail}</span></Link>
            </div>
            <button className="open-menu btn-new"><Glyphicon glyph="menu-hamburger"/></button>
          </header>
        );
      }

    }
    else{
      return (
        <header className="menu">
          <button className="open-menu btn-new"><Glyphicon glyph="menu-hamburger"/></button>
        </header>
      );
    }
  },

  logout: function(event) {

    event.preventDefault();
    UserHandler.logout(true);

    return this.context.router.push("/signin");
  },

});



// WEBPACK FOOTER //
// ./src/js/components/elements/sdk-header.jsx